<template>
  <div>
    <!-- header title -->
    <div v-if="headTitle" class="font-weight-bold mb-3 header__title">
      {{ headTitle }}
    </div>

    <!-- description -->
    <div
      v-if="criterion.title && criterion.title.length"
      class="font-weight-normal mb-1 text__title"
    >
      {{ criterion.title }}
    </div>

    <!-- description -->
    <div
      v-if="criterion.description && criterion.description.length"
      class="font-weight-normal mb-1 text__description"
    >
      {{ criterion.description }}
    </div>

    <!-- criterion : In case show info -->
    <div>
      <!-- pass -->
      <div class="container__criteria-pass container-criteria-level-1">
        <b-form-radio
          v-if="isReview"
          v-model="isSelectedPass"
          class="my-3 pass-criteria-radio criteria-level-1-radio"
          :name="`pass-critera-radio-${criterion.id}`"
          value="pass"
          @change="onPassCriteriaSelected"
        >
          <h5 class="font-weight-bold text__criteria-title text__criteria-level-1-title">
            {{ criterion.pass_title }}
          </h5>

          <div
            v-safe-html="criterion.pass_criterion"
            class="text__criteria-description text__criteria-level-1-description text-pre-wrap mt-2"
          />
        </b-form-radio>

        <div v-else class="text__criteria-info">
          <div class="icon__criteria">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="rgba(12,107,126,1)"
            >
              <path
                d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"
              ></path>
            </svg>
          </div>
          <div class="text__criteria">
            <div class="font-weight-bold text__criteria-title text__criteria-level-1-title">
              {{ criterion.pass_title }}
            </div>
            <div
              v-safe-html="criterion.pass_criterion"
              class="text__criteria-description text__criteria-level-1-description"
            />
          </div>
        </div>
      </div>

      <!-- additional criteria -->
      <div v-if="additionalCriteria.length" class="container__additional-criteria-list">
        <div
          v-for="(additionalCriterion, additionalCriterionIndex) in additionalCriteria"
          :key="`additional-criteria-${additionalCriterion.id}`"
          class="container__additional-criteria"
          :class="{
            [`container__criteria-level-${additionalLevel(additionalCriterionIndex + 1)}`]: true
          }"
        >
          <b-form-radio
            v-if="isReview"
            v-model="isSelectedPass"
            class="my-3 additional-criteria-radio"
            :class="{
              [`criteria-level-${additionalLevel(additionalCriterionIndex + 1)}-radio`]: true
            }"
            :name="`additional-criteria-radio-${additionalCriterion.id}`"
            :value="additionalCriterion.title"
            @change="onAddtionalCriteriaSelected"
          >
            <h5
              class="font-weight-bold text__criteria-title"
              :class="{
                [`text__criteria-level-${additionalLevel(
                  additionalCriterionIndex + 1
                )}-title`]: true
              }"
            >
              {{ additionalCriterion.title }}
            </h5>

            <div
              v-safe-html="additionalCriterion.description"
              class="text__criteria-description text-pre-wrap text-dark mt-2"
              :class="{
                [`text__criteria-level-${additionalLevel(
                  additionalCriterionIndex + 1
                )}-description`]: true
              }"
            />
          </b-form-radio>

          <div v-else class="text__criteria-info">
            <div class="icon__criteria">
              <div class="icon__criteria">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  fill="rgba(130, 66, 36, 1)"
                >
                  <path
                    d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="text__criteria">
              <div
                class="font-weight-bold text__criteria-title"
                :class="{
                  [`text__criteria-level-${additionalLevel(
                    additionalCriterionIndex + 1
                  )}-title`]: true
                }"
              >
                {{ additionalCriterion.title }}
              </div>

              <div
                v-safe-html="additionalCriterion.description"
                class="text__criteria-description"
                :class="{
                  [`text__criteria-level-${additionalLevel(
                    additionalCriterionIndex + 1
                  )}-description`]: true
                }"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- not yet -->
      <div
        class="container__criteria-not-yet"
        :class="{ [`container-criteria-level-${notYetLevel}`]: true }"
      >
        <b-form-radio
          v-if="isReview"
          v-model="isSelectedPass"
          class="my-3 not-yet-criterion-radio"
          :class="{ [`criteria-level-${notYetLevel}-radio`]: true }"
          :name="`not-yet-criterion-radio-${criterion.id}`"
          value="notYet"
          @change="onNotPassCriteriaSelected"
        >
          <h5
            class="font-weight-bold text__criteria-title"
            :class="{ [`text__criteria-level-${notYetLevel}-title`]: true }"
          >
            {{ criterion.not_yet_title }}
          </h5>

          <div
            v-safe-html="criterion.not_yet_criterion"
            class="text__criteria-description text-pre-wrap text-dark mt-2"
            :class="{
              [`text__criteria-level-${notYetLevel}-description`]: true
            }"
          />
        </b-form-radio>

        <div v-else class="text__criteria-info">
          <div class="icon__criteria">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="rgba(132,30,48,1)"
            >
              <path
                d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
              ></path>
            </svg>
          </div>

          <div class="text__criteria">
            <div
              :class="{ [`text__criteria-level-${notYetLevel}-title`]: true }"
              class="font-weight-bold text__criteria-title"
            >
              {{ criterion.not_yet_title }}
            </div>
            <div
              v-safe-html="criterion.not_yet_criterion"
              class="text__criteria-description"
              :class="{
                [`text__criteria-level-${notYetLevel}-description`]: true
              }"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- criterion : In case evaluated -->
    <!-- <div v-if="pass !== null && !isReview">
      <div class="d-flex flex-row container__criteria-pass mt-4">
        <div>
          <font-awesome-icon
            icon="check-circle"
            class="font-size-lg btn__icon mr-3"
            :class="classPass"
          />
        </div>
        <div class="font-weight-normal h5" :class="classPass">Pass</div>
      </div>

      <div class="d-flex flex-row container__criteria-not-yet mt-3">
        <div>
          <font-awesome-icon
            icon="times-circle"
            class="font-size-lg btn__icon mr-3"
            :class="classNotYet"
          />
        </div>
        <div class="font-weight-normal h5" :class="classNotYet">Not yet</div>
      </div>
    </div> -->

    <!-- Review -->
    <!-- <b-form-radio-group v-if="isReview" class="mt-3">
      <div class="d-flex flex-row container__criteria-pass mb-3">
        <b-form-radio
          v-model="isSelectedPass"
          class="my-1 pass-criterion-radio"
          :name="`pass-criterion-radio-${criterion.id}`"
          :value="true"
          @change="onSelectedRadio(criterion)"
        >
          <div class="font-weight-bold h5">Pass</div>
          <div
            class="text__criteria-description text-pre-wrap text-dark mt-2"
            v-html="criterion.pass_criterion"
          />
        </b-form-radio>
      </div>

      <div class="d-flex flex-row container__criteria-not-yet">
        <b-form-radio
          v-model="isSelectedPass"
          class="my-1 not-yet-criterion-radio"
          :name="`not-yet-criterion-radio-${criterion.id}`"
          :value="false"
          @change="onSelectedRadio(criterion)"
        >
          <div class="font-weight-bold h5">Not yet</div>
          <div
            class="text__criteria-description text-pre-wrap text-dark mt-2"
            v-html="criterion.not_yet_criterion"
          />
        </b-form-radio>
      </div>
    </b-form-radio-group> -->

    <!-- Passed or Feedback -->
    <!-- <div v-if="!isReview" class="mt-3">
        <div class="d-flex flex-row container__criteria-pass">
          <div
            class="my-2 font-weight-normal h5"
            :class="{ 'text-success': pass }"
          >
            <font-awesome-icon
              :icon="{ prefix: 'fas', iconName: 'check-circle' }"
              class="font-size-sm mr-2"
            />
            Pass
          </div>
        </div>
        <div class="d-flex flex-row container__criteria-not-yet">
          <div
            class="my-2 font-weight-normal h5"
            :class="{ 'text-danger': !pass }"
          >
            <font-awesome-icon
              :icon="{ prefix: 'fas', iconName: 'times-circle' }"
              class="font-size-sm mr-2"
            />
            Not yet
          </div>
        </div>
      </div> -->
  </div>
</template>

<script>
/**
 * Show criterion both learning outcome & addtional criterion
 * there have 2 type : show info & evaluated
 * if evaluated need to pass props "pass"
 *
 * example: @/examples/ShowCriterion.vue
 */

import { AssessmentEvaluation } from '@/models/AssessmentEvaluation';
import { AdditionalCriterion } from '@/models/AdditionalCriterion';
import { Criteria } from '@/models/Criteria';
// import { LearningOutcome } from "@/models/LearningOutcome";

export default {
  props: {
    index: {
      type: [Number, String],
      default: null
    },

    criterion: {
      type: Criteria,
      required: true
    },

    headTitle: {
      type: String,
      default: ''
    },

    isReview: {
      type: Boolean,
      default: false
    },

    assessmentEvaluation: {
      type: AssessmentEvaluation,
      default: null
    }
  },

  data() {
    return {
      isSelectedPass: ''
    };
  },

  computed: {
    additionalCriteria() {
      const { additional_criterion_ids = [] } = this.criterion;

      return AdditionalCriterion.findIn(additional_criterion_ids);
    },

    notYetLevel() {
      const { additionalCriteria = [] } = this;

      return 2 + additionalCriteria.length;
    }
  },

  methods: {
    additionalLevel(index) {
      return 1 + index;
    },

    onPassCriteriaSelected() {
      // this.$emit("change", updatedValue, this.isSelectedPass);
    },

    onNotPassCriteriaSelected() {
      // this.$emit("change", updatedValue, this.isSelectedPass);
    },

    onAddtionalCriteriaSelected() {}

    // onSelectedRadio(updatedValue) {
    //   this.$emit("onSelectedRadio", updatedValue, this.isSelectedPass);
    // },
  }
};
</script>

<style lang="scss" scoped>
.text__criteria-info {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.container__criteria-pass,
.container__criteria-not-yet,
.container__additional-criteria {
  padding: 12px 20px;
  border-radius: 10.4px;
  border: 1px solid;
  margin-bottom: 12px;

  .text__criteria-description {
    white-space: pre-wrap;
    word-break: break-word;
  }
}

.container__criteria-pass {
  background: #cff3f8;
  border-color: #bceff5;

  .text__criteria-title,
  .text__criteria-description {
    color: #0c6b7e;
  }
}

.container__criteria-not-yet {
  background: #fed6da;
  border-color: #fdc6cb;

  .text__criteria-title,
  .text__criteria-description {
    color: #841e30;
  }
}

.container__additional-criteria {
  background: #fde4d5;
  border-color: #fcd9c4;

  .text__criteria-title,
  .text__criteria-description {
    color: #824224;
  }
}
</style>
